import { MARKETING_MATURE } from '@src/view/components/viewer/data';
import { ThumbnailKey, ThumbnailMode } from './_constants';
import { ThumbnailType } from './BaseType';
import { TopcoPartner } from '@src/lib/marketing/TopcoPartner';
import { UserSession } from '@src/lib';
import _ from 'lodash';

const SLICE_SIZE = 2;

export const initRealTimeThumb = {
  height: 137,
  width: 226,
  path: 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==',
};

export const initThumb = {
  height: 500,
  width: 300,
  path: 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==',
};

/**
 * ANCHOR: 이미지 원본 데이터 추출용
 * @param data
 * @param key
 * @param index
 * @returns width, height, path
 */
export const imgParser = (
  data: any,
  key: string,
  index: number = 0,
): ThumbnailType | null => {
  if (!data || !_.has(data, key) || !_.isArray(data[key])) return null;

  if (data[key].length > index) return data[key][index];

  return data[key].length > 0 ? data[key][0] : null;
};

/**
 * ANCHOR: 이미지 데이터 리스트 추출용
 * * 리스트 반환
 * * max length 없으면 slice 하지 않음.
 * @param data
 * @param key
 * @param index
 * @param maxLength
 * @returns width, height, path
 */
const imgListSlicer = (
  data: any,
  key: string,
  maxLength: number = 0,
): ThumbnailType[] => {
  if (!data || !_.has(data, key) || !_.isArray(data[key])) return [];

  if (data[key].length < 0) return [];

  if (maxLength === 0) return data[key];

  return data[key].slice(0, maxLength);
};

export const imgsParser = (data: any, key: string): ThumbnailType[] => {
  if (!data || !_.has(data, key) || !_.isArray(data[key])) return [initThumb];
  return data[key].length > 0 ? data[key] : [initThumb];
};

/**
 * ANCHOR: 회차 썸네일 가공 - thumbnailImage 키의 [0][1] 번쨰로 가공하는 함수
 * - 0번째:성인, 1번째:17금
 * @param props
 * @returns
 */
export const convertEpiThumbnailImage = (data: any): ThumbnailType => {
  const { mature } = UserSession.getUserInfo();
  if (mature === 1) {
    const thumbnail = imgParser(data[ThumbnailKey.THUMBNAIL], 'webp');
    return thumbnail ?? initThumb;
  }
  // imgParser에서 1번째 이미지 없으면 알아서 0번째 이미지 가져옴.
  const thumbnail17 = imgParser(data[ThumbnailKey.THUMBNAIL], 'webp', 1);
  return thumbnail17 ?? initThumb;
};

/**
 * 회차리스트 thumbnail 가져오기 정책
 * * 백엔드에서 vertical, vertical17 둘다 주지만
 * * vertical이 일반/ 17/ 광고용 19 분기처리한 데이터이므로 프론트는 vertical만 보면됨
 * * slice는 프론트에서 함.
 * @param param0
 * @returns
 */
export const convertEpiVerticalThumbnail = (
  data: any,
  mode?: ThumbnailMode, // 강제 비성인(is17)만 있었는데, 마케팅용 강제 성인이 추가되어 매개변수 변경
): ThumbnailType[] => {
  const thumbnail = imgsParser(data[ThumbnailKey.VERTICAL], 'webp');

  let sliceThumbnail = thumbnail;
  if (mode === ThumbnailMode.NORMAL) {
    sliceThumbnail = _.slice(thumbnail, 0, 2);
  } else {
    sliceThumbnail = _.slice(thumbnail, 0, 1);
  }
  return sliceThumbnail;
};
